import React from "react";
import "../css/Features.css";

export default function Features() {
  return (
    <section className="features">
      <div className="features-bg" />

      <div className="features-wrapper">
        {/* INTRO */}
        <div className="features-intro">
          <span className="features-label">Our Features</span>

          <h1 className="features-title">
            Powerful <span>Capabilities</span> for Your Business
          </h1>

          <p className="features-lead">
            Inquizene provides modern software solutions with features designed
            to streamline operations, increase productivity, and enhance user experience.
          </p>
        </div>

        {/* FEATURES GRID */}
        <div className="features-grid">
          <div className="features-column">
            <h3>Automation</h3>
            <p>
              Reduce manual work and improve efficiency with intelligent automation
              across your business processes.
            </p>
          </div>

          <div className="features-column">
            <h3>Analytics</h3>
            <p>
              Gain insights into your operations with real-time analytics and
              data-driven decision-making tools.
            </p>
          </div>

          <div className="features-column highlight">
            <h3>Scalability</h3>
            <p>
              Our software grows with your business, ensuring high performance and
              reliability at every stage.
            </p>
          </div>

          <div className="features-column">
            <h3>Security</h3>
            <p>
              Keep your data safe with robust security protocols and compliance
              standards built-in by default.
            </p>
          </div>

          <div className="features-column">
            <h3>Integration</h3>
            <p>
              Seamlessly connect with other systems and tools to create a unified
              workflow.
            </p>
          </div>

          <div className="features-column highlight">
            <h3>Custom Solutions</h3>
            <p>
              Tailored solutions to meet your specific business requirements
              without compromise.
            </p>
          </div>
        </div>

        {/* CTA */}
        <div className="features-cta-bar">
          <div>
            <h4>Ready to enhance your operations?</h4>
            <p>
              Let’s explore how Inquizene can deliver features that drive your
              business forward.
            </p>
          </div>

          <div className="features-actions">
            <button className="btn-primary">Get Started</button>
            <button className="btn-secondary">Learn More</button>
          </div>
        </div>
      </div>
    </section>
  );
}
